import { z } from 'zod';
import { pageIdSchema } from '@deckspace/ids';
import { catalogSchemas } from './visualizations/index.js';
const componentTypeEnum = z.enum(Array.from(catalogSchemas.keys()));
const componentNodeSchema = z.object({
    id: z.string().min(1),
    type: componentTypeEnum,
    children: z.array(z.string().min(1)).optional(),
    props: z.record(z.string(), z.unknown()).optional(),
});
const componentUpdateSchema = z.object({
    nodeId: z.string().min(1),
    props: z.record(z.string(), z.unknown()).optional(),
    children: z.array(z.string().min(1)).optional(),
    remove: z.boolean().optional(),
});
const palettePresetEnum = z.enum([
    'default',
    'warm',
    'cool',
    'earth',
    'monochrome',
    'ocean',
    'sunset',
]);
const paletteTokenEnum = z.enum([
    'blue',
    'emerald',
    'amber',
    'rose',
    'violet',
    'cyan',
    'orange',
    'slate',
]);
const colorIntentEnum = z.enum(['neutral', 'positive-negative', 'comparison', 'diverging']);
const surfaceThemeSchema = z.strictObject({
    palette: palettePresetEnum.optional(),
    primary: paletteTokenEnum.optional(),
    accent: paletteTokenEnum.optional(),
    colorIntent: colorIntentEnum.optional(),
});
/**
 * Surface input schema — pageId-centric model.
 *
 * Create/rebuild: pageId + components — upserts the page's single surface.
 * Surgical update: pageId + updates — patches nodes in the existing tree.
 *
 * workspaceId and surface id are no longer required; the handler derives
 * workspaceId from the page, and the surface is owned by the page.
 */
export const surfaceInputSchema = z
    .object({
    pageId: pageIdSchema,
    components: z.array(componentNodeSchema).min(1).optional(),
    updates: z.array(componentUpdateSchema).optional(),
    theme: surfaceThemeSchema.optional(),
})
    .refine((data) => data.components || data.updates, {
    message: 'Either components or updates must be provided',
});
//# sourceMappingURL=surface-input-schema.js.map